// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"730":"6360bcc2","787":"73338dfa"}[chunkId] + ".chunk.js";
};